import { getLongMonthDateWithoutYear } from '@lmt/unicorn-shared/app/components/patients/common';
import { EmptyBlock } from '@lmt/unicorn-shared/app/components/patients/profile/overview/components/EmptyBlock';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { addDays } from 'date-fns';
import React, { useState } from 'react';
import { PlannedVisitInfo, PlannedVisitItem } from './PlannedVisitItem';

import styles from './PlannedVisitsPanel.module.scss';
import { startOfToday } from 'date-fns';

export interface PlannedVisitsPanelProps {
  plannedVisits: PlannedVisitInfo[];
  openPatientTab: (patientId: number) => void;
  openCaseVisitTab: (
    patientId: number,
    caseId: number,
    visitId: number,
  ) => void;
}

export const PlannedVisitsPanel: React.FC<PlannedVisitsPanelProps> = (
  props,
) => {
  const { plannedVisits, openPatientTab, openCaseVisitTab } = props;
  const i18next = useScopedTranslation('dashboard.planned_visits');
  const [currentTab, setCurrentTab] = useState<
    'today' | 'tomorrow' | 'dayAfterTomorrow'
  >('today');

  const today = startOfToday();
  const tommorrow = addDays(today, 1);
  const dayAfterTommorrow = addDays(today, 2);
  const groupedVisits = plannedVisits
    .filter((visit) =>
      currentTab === 'today'
        ? visit.startDate.getDate() === today.getDate()
        : currentTab === 'tomorrow'
          ? visit.startDate.getDate() === tommorrow.getDate()
          : visit.startDate.getDate() === dayAfterTommorrow.getDate(),
    )
    .sort((a, b) => a.startDate!.getHours() - b.startDate!.getHours());

  const visitListComponent = (
    <div className={styles.visits}>
      {groupedVisits.map((visit) => (
        <div key={visit.id} className={styles.visitContainer}>
          <PlannedVisitItem
            visit={visit}
            openPatientTab={openPatientTab}
            openCaseVisitTab={openCaseVisitTab}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles.container} data-test-id="planned-visits-block">
      <div className={styles.header}>
        <div className={styles.title}>{i18next.t('title')}</div>
        <div className={styles.tabs} data-test-id="planned-visits-block-tabs">
          <div
            className={styles.tab}
            data-selected={currentTab === 'today'}
            onClick={() => setCurrentTab('today')}
          >
            {`${i18next.t('today')}, ${getLongMonthDateWithoutYear(today)}`}
          </div>
          <div
            className={styles.tab}
            data-selected={currentTab === 'tomorrow'}
            onClick={() => setCurrentTab('tomorrow')}
          >
            {`${i18next.t('tomorrow')}, ${getLongMonthDateWithoutYear(
              tommorrow,
            )}`}
          </div>
          <div
            className={styles.tab}
            data-selected={currentTab === 'dayAfterTomorrow'}
            onClick={() => setCurrentTab('dayAfterTomorrow')}
          >
            {getLongMonthDateWithoutYear(dayAfterTommorrow)}
          </div>
        </div>
      </div>
      {Object.keys(groupedVisits).length > 0 ? (
        visitListComponent
      ) : (
        <EmptyBlock title={''} text={i18next.t('empty')} />
      )}
    </div>
  );
};
